// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xWiW","colMin":"styles_colMin__1um-q"};